import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/lineLogin.vue'
import modeView from '../views/modeView.vue'
import paymentBanking from '../views/payment-banking.vue'
import testView from '../views/testView.vue'
// import linelogin from '../views/test-linelogin.html'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // {
  //   path: '/',
  //   name: 'lineLogin',
  //   component: lineLogin
  // },
  {
    path: '/modeView',
    name: 'modeView',
    component: modeView,
    props: (route) => ({ machineID: route.query.name })
  },
  {
    path: '/payment',
    name: 'Payment',
    component: paymentBanking
  },
  {
    path: '/test',
    name: 'test',
    component: testView
  },
  // {
  //   path: '/linelogin',
  //   name: 'linelogin',
  //   component: linelogin
  // },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
